import React, {Component} from "react";
import {Router, Route, Switch} from 'react-router-dom';
import {connect} from 'react-redux';
import {withNamespaces} from "react-i18next"
import indexRoutes from "../../routes/index.jsx";
import {history} from '../../authentication/_helpers';
import {alertActions} from '../../authentication/_actions';
import {PrivateRoute} from '../../authentication/_components';

class App extends Component {

    constructor(props) {
        super(props);

        const {dispatch} = this.props;

        history.listen((location, action) => {
            dispatch(alertActions.clear());
        });

        const {i18n} = this.props;

        if (localStorage.getItem('language') === undefined || localStorage.getItem('language') === null) {
            localStorage.setItem('language', 'en');
            i18n.changeLanguage('en');
        }
        else {
            i18n.changeLanguage(localStorage.getItem('language'))
        }

    }

    render() {
        const {alert, dispatch} = this.props;
        const isDashboardRoute = !history.location.pathname.startsWith('/user');

        return (
            <div>
                {alert.message &&
                <div className={`global-alert-layer ${isDashboardRoute ? 'global-alert-layer-dashboard' : 'global-alert-layer-auth'}`}>
                    <div className={`alert ${alert.type} global-alert-banner`} role="alert" aria-live="assertive">
                        <span className="global-alert-message">{alert.message}</span>
                        <button
                            type="button"
                            className="global-alert-close"
                            aria-label="Close alert"
                            onClick={() => dispatch(alertActions.clear())}
                        >
                            x
                        </button>
                    </div>
                </div>
                }
                <Router history={history}>
                    <Switch>
                        {indexRoutes.map((prop, key) => {
                            if (key === 1) {
                                return <PrivateRoute path={prop.path} component={prop.component} key={key}/>;
                            } else {
                                return <Route path={prop.path} component={prop.component} key={key}/>;
                            }
                        })}
                    </Switch>
                </Router>
            </div>
        );
    }
}

function mapStateToProps(state) {
    const {alert} = state;
    return {
        alert
    };
}

const connectedApp = connect(mapStateToProps)(App);
const connectedAppTrans = withNamespaces('common')(connectedApp);
export {connectedAppTrans as App};
